module.exports = __webpack_public_path__ + "static/media/nn-Arbeidsminne-No-kjem-det-flei-ord.1372e87d.mp3";